/**
 * Where a schedule page was opened from, so the right tab is highlighted and
 * the "back" link goes where the person came from. A schedule opened from an
 * Admin page belongs to Admin (a draft is visible only there); any other
 * schedule page (from History, a bookmark, a shared address) belongs to
 * History. Carried in the router's location state, which survives a reload.
 */
export const FROM_ADMIN = { from: 'admin' } as const;

export function openedFromAdmin(state: unknown): boolean {
  return typeof state === 'object' && state !== null && (state as { from?: unknown }).from === 'admin';
}
